module.exports = __webpack_public_path__ + "img/service_img11.a56c363a.png";